module.exports = __webpack_public_path__ + "1ed27c9675a2abf9d254b688841e9d31.png";